import { WorkflowElementType } from './Enums/workflow-element-type';

/**
 * Represente un avertissement retourné par la validation du workflow.
 */
export class WorkflowValidityWarning {
    /**
     * Message d'avertissement.
     */
    public message: string = null;

    /**
     * Type de l'élément qui est à la source de l'avertissement.
     */
    public sourceType: WorkflowElementType = null;

    /**
     * Identifiant de l'élément qui est à la source de l'avertissement.
     */
    public sourceId: number = null;

    /**
     * Retourne une copie d'une instance de WorkflowValidityWarning
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: WorkflowValidityWarning) {
        if (!!other) {
            const instance = new WorkflowValidityWarning();
            instance.message = other.message;
            instance.sourceType = other.sourceType;
            instance.sourceId = other.sourceId;

            return instance;
        } else {
            return null;
        }
    }

    /**
     * Retourne une copie d'un tableau d'instances de WorkflowValidityError
     * @param other : Tableau source.
     * @returns : Copie du tableau.
     */
    public static cloneArray(others: WorkflowValidityWarning[]) {
        if (!!others) {
            let warnings: WorkflowValidityWarning[] = [];

            others.forEach((x) => {
                const warning = WorkflowValidityWarning.clone(x);
                warnings.push(warning);
            });

            return warnings;
        } else {
            return [];
        }
    }
}
